import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardListIcon, SmartphoneIcon, ShieldCheckIcon } from 'lucide-react';
export function TheDifferentiator() {
  const points = [{
    title: "Your vehicle's actual history",
    desc: "We pull your records and cross-reference against manufacturer intervals. You don't have to remember everything — we track it.",
    icon: ClipboardListIcon
  }, {
    title: 'Everything documented',
    desc: 'Photos and video of your vehicle. Plain-English notes. Prioritized by urgency. Sent to your phone before anything is approved.',
    icon: SmartphoneIcon
  }, {
    title: 'Nothing without your go-ahead',
    desc: 'Clear estimate before any work starts. You decide what happens now and what can wait.',
    icon: ShieldCheckIcon
  }];
  return <section id="differentiator" className="relative overflow-hidden bg-brand-dark px-4 py-20 text-white" data-id="element-175" data-mp="3f9qws9k2wgja">
      <div className="absolute inset-x-0 top-0 z-0 h-[340px] md:h-[440px]" data-id="element-176" data-mp="3jaaw9js4jw8l">
        <img src="https://cdn.magicpatterns.com/uploads/qrN4Afcysw5WuSXhZNg5GH/Used-0316_Profile_RW_007.jpg" alt="" aria-hidden="true" className="h-full w-full object-cover" data-id="element-177" data-mp="35nz0k1462se3" />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/5 via-brand-dark/45 to-brand-dark" data-id="element-178" data-mp="3amti6zqeeawm" />
      </div>

      <div className="relative z-10 mx-auto max-w-5xl pt-40 md:pt-56" data-id="element-179" data-mp="3om1ixx27lr2x">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-180" data-mp="3ok8d2jzf7avz">
          <img src="https://cdn.magicpatterns.com/uploads/v5w4cpb7uAJvjUTD8b3jRB/Lancer_Circle3x.png" alt="Lancer Service" className="mx-auto mb-8 h-40 w-40 object-contain drop-shadow-lg" data-id="element-181" data-mp="b7y8tc1sxn2d" />
          <span className="mb-4 block text-sm font-bold uppercase tracking-widest text-brand-accent" data-id="element-182" data-mp="34zepf341spi2">
            HOW WE WORK
          </span>
          <h2 className="mx-auto mb-8 max-w-4xl font-heading text-3xl font-extrabold uppercase tracking-wide md:text-4xl lg:text-5xl" data-id="element-183" data-mp="390gg2vjwft8f">
            WE BUILD YOUR MAINTENANCE PLAN AROUND YOUR VEHICLE. NOT A GENERIC
            SCHEDULE.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="mx-auto mb-16 max-w-4xl space-y-6 text-center text-lg leading-relaxed text-gray-300 md:text-xl" data-id="element-184" data-mp="3npmlj19byfor">
          <p data-id="element-185" data-mp="22d30fs3ptia7">
            When you come to Lancer, we don&apos;t just do what you asked for
            and hand you your keys. We pull your vehicle history,
            cross-reference what&apos;s been done against your
            manufacturer&apos;s recommended intervals, and identify what&apos;s
            due, what&apos;s coming up, and what can wait.
          </p>
          <p data-id="element-186" data-mp="1h36sq7td1vpl">
            Every maintenance visit includes a full 47-point Digital Vehicle
            Inspection — photos and video of your actual car, sent to your
            phone, with technician notes in plain English. You see exactly what
            we see. Every recommendation is prioritized by urgency and delivered
            as a clear estimate before any work begins.
          </p>
          <p data-id="element-187" data-mp="1zrljctzrn7pv">
            If something isn&apos;t due yet, we&apos;ll tell you. If something
            can wait, we&apos;ll say so. The goal is a plan you can actually
            follow — not a list of services we think we can sell you.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8" data-id="element-188" data-mp="2c9eav4n16hvo">
          {points.map((point, index) => {
          const Icon = point.icon;
          return <motion.div key={point.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex flex-col items-center rounded-2xl border border-gray-700 bg-gray-800/50 p-8 text-center" data-id="element-189" data-mp="23980hrmmpy0q" data-mpi={index}>
                <div className="mb-6 rounded-full border border-gray-700 bg-gray-900 p-4" data-id="element-190" data-mp="1akk8ld7dkae7">
                  <Icon className="h-8 w-8 text-brand-accent" data-id="element-191" data-mp="1fjne0yr9oimp" />
                </div>
                <h3 className="mb-3 font-heading text-lg font-bold uppercase tracking-wide text-white" data-id="element-192" data-mp="1fhkeno485d5b">
                  {point.title}
                </h3>
                <p className="text-gray-300" data-id="element-193" data-mp="12zzvtl9c55yk">{point.desc}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}